import { Grid } from '@material-ui/core'
import Frotista from 'modules/user/domain/entities/Frotista'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import React, { useState } from 'react'

import { colors } from '../../styles/colors'
import Autocomplete from '../Autocomplete'
import Button from '../Button'
import Modal from '../Modal'
import SnackBar from '../SnackBar'
import Text from '../Text'
import { BodyRow, ContainerBody } from './styles'
import EStatusConta from '../../../modules/lotes/domain/entities/EStatusConta'

interface ISelectFrotistaProps {
  openModalSelectFrotista: boolean
  setOpenModalSelectFrotista: (value: boolean) => void
  setCancelModalSelectFrotista?: () => void
  setUpdateCartao?: (value: boolean) => void
}

const ModalSelectFrotista: React.FC<ISelectFrotistaProps> = ({
  openModalSelectFrotista,
  setOpenModalSelectFrotista,
  setCancelModalSelectFrotista,
  setUpdateCartao,
}) => {
  const { frotistas, setFrotistaId, setFrotista } = useFrotista()
  const [openAlert, setOpenAlert] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const values = [
    { razao_social: 'Selecione um frotista' } as Frotista,
    ...frotistas,
  ]
  const [selectedFrotista, setSelectedFrotista] = useState<Frotista>(values[0])

  const handleClickSelectFrotista = (): void => {
    if (selectedFrotista) {
      setOpenModalSelectFrotista(false)
      setFrotistaId(selectedFrotista.id)
      setFrotista(selectedFrotista)
      if (setUpdateCartao) {
        setUpdateCartao(true)
      }
    } else {
      setOpenAlert(true)
      setErrorMessage('Você deve selecionar um CNPJ para continuar')
    }
  }

  const closeButton = (): void => {
    if (setCancelModalSelectFrotista) {
      setCancelModalSelectFrotista()
    }
    setSelectedFrotista(values[0])
    setFrotistaId(null)
    setOpenModalSelectFrotista(false)
  }

  const buildBodyRow = (label: string, value: string): JSX.Element => {
    return (
      <BodyRow>
        <div>{label}</div>
        <div>
          <strong>{value}</strong>
        </div>
      </BodyRow>
    )
  }

  return (
    <>
      <Modal
        size="medium"
        openModal={openModalSelectFrotista}
        showCloseButton={false}
      >
        <Text style={{ marginTop: 30, marginBottom: 10 }}>
          Selecione um CNPJ
        </Text>
        <Grid container>
          <Grid item md={12} style={{ marginBottom: 15, width: '100%' }}>
            <Autocomplete
              label=""
              value={selectedFrotista}
              placeholder="Digite para buscar ou selecione na lista"
              options={values}
              getOptionDisabled={option => option.id === undefined}
              onChange={(_, newValue: Frotista) =>
                setSelectedFrotista(newValue)
              }
              getOptionLabel={option =>
                (option as Frotista).id
                  ? (option as Frotista).cnpj +
                    ' - ' +
                    (option as Frotista)?.razao_social
                  : (option as Frotista)?.razao_social
              }
            />
          </Grid>
          <ContainerBody>
            {buildBodyRow('CNPJ', selectedFrotista?.cnpj)}
            {buildBodyRow('Razão Social', selectedFrotista?.razao_social)}
            {buildBodyRow('Nome Fantasia', selectedFrotista?.nome_fantasia)}
          </ContainerBody>
        </Grid>
        <>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid
              item
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button color={colors.green} onClick={handleClickSelectFrotista}>
                Selecionar
              </Button>
            </Grid>
            <Grid
              item
              md={6}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button color={colors.orange} onClick={closeButton}>
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </>
      </Modal>
      <SnackBar
        open={openAlert}
        setOpen={setOpenAlert}
        severity="error"
        message={errorMessage}
      />
    </>
  )
}

export default ModalSelectFrotista
